
import { Component, Prop, Vue } from 'vue-property-decorator'
import { CreateElement, VNode } from 'vue'
import { TypeformReferenceRegExp } from '@/api/model/typeform/typeform-form'
import { TypeformResponseDefinitionField } from '@/api/model/typeform/typeform-response-definition-field'
import { TypeformMap } from '@/api/model/typeform/typeform-map'
import { TypeformResponseVariable } from '@/api/model/typeform/typeform-response-variable'

@Component
export default class HighlightReferences extends Vue {
    @Prop({ required: true }) readonly fields!: TypeformResponseDefinitionField[]
    @Prop({ required: true }) readonly content!: string
    @Prop({ required: true }) readonly hidden!: TypeformMap
    @Prop({ required: true }) readonly variables!: TypeformResponseVariable[]

    render(createElement: CreateElement): VNode {
        const children = []

        const contentParts = this.content.split(TypeformReferenceRegExp)
        while (contentParts.length) {
            const contentPart = contentParts.shift()
            if (contentPart.match(TypeformReferenceRegExp)) {
                const referenceType = contentParts.shift()
                const reference = contentParts.shift()
                let label = reference

                if (referenceType === 'hidden') {
                    label = this.hidden[reference] as string
                }

                if (referenceType === 'field') {
                    const field = this.fields.find(f => f.fieldRef === reference)
                    if (field) {
                        label = field.fieldTitle.replaceAll(TypeformReferenceRegExp, '_')
                    }
                }

                children.push(createElement(
                    'span',
                    {
                        class: 'inline-block px-1 bg-green-100 border border-dashed border-green-200 font-normal font-regular text-sm text-green-600',
                    },
                    label,
                ))
            } else {
                children.push(contentPart)
            }
        }

        return createElement(
            'span',
            {},
            children,
        )
    }
}
